import { render, staticRenderFns } from "./quickActions.vue?vue&type=template&id=2bad9080"
import script from "./quickActions.vue?vue&type=script&lang=js"
export * from "./quickActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports